import React from 'react'
import { createRoot } from 'react-dom/client'
import TeamPublicPageApp from '../components/TeamPublicPage/TeamPublicPageApp'
import { showActivityNotifications } from 'utils/socialProofToast'

const VISITOR_TOKEN_KEY = 'tn_visitor_token'

function backupVisitorToken() {
  const cookie = document.cookie.split('; ')
    .find(c => c.startsWith('team_visitor_token='))
  if (cookie) {
    const token = cookie.split('=')[1]
    localStorage.setItem(VISITOR_TOKEN_KEY, token)
  }
}

function restoreVisitorToken() {
  const hasCookie = document.cookie.includes('team_visitor_token=')
  if (!hasCookie) {
    const saved = localStorage.getItem(VISITOR_TOKEN_KEY)
    if (saved) {
      const expires = new Date(Date.now() + 90 * 24 * 60 * 60 * 1000).toUTCString()
      document.cookie = `team_visitor_token=${saved}; expires=${expires}; path=/`
    }
  }
}

// Restore before server request on next navigation
restoreVisitorToken()

document.addEventListener('DOMContentLoaded', () => {
  // Backup after server has set the cookie
  backupVisitorToken()

  const container = document.getElementById('team-public-page')
  if (container) {
    const initialData = JSON.parse(container.dataset.teamData)
    const teamSlug = container.dataset.teamSlug

    // Activity notifications from server
    showActivityNotifications(initialData.recentActivity)

    const root = createRoot(container)
    root.render(
      <TeamPublicPageApp
        initialData={initialData}
        teamSlug={teamSlug}
      />
    )
  }
})
